"use client";

import type { KeyboardEvent, ReactNode } from "react";

import { clsx } from "clsx";

export function MediaRow({
  children,
  className,
  isSelected,
  onSelect,
}: {
  children: ReactNode;
  className?: string;
  isSelected: boolean;
  onSelect?: () => void;
}) {
  const isInteractive = !!onSelect;

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect?.();
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      const rows = event.currentTarget.parentElement?.querySelectorAll<HTMLElement>("[role='button']");
      if (!rows) return;
      const items = Array.from(rows);
      const current = items.indexOf(event.currentTarget);
      const next = event.key === "ArrowDown" ? Math.min(current + 1, items.length - 1) : Math.max(current - 1, 0);
      items[next]?.focus();
    }
  };

  return (
    <div
      {...(isInteractive && {
        role: "button",
        tabIndex: 0,
        "aria-pressed": isSelected,
        onClick: onSelect,
        onKeyDown: handleKeyDown,
      })}
      className={clsx(
        "tw-group/media-row tw-flex tw-h-[52px] tw-w-full tw-items-center tw-gap-2 tw-rounded-2xl tw-px-3 tw-py-2.5 tw-outline-none tw-transition-colors tw-duration-150",
        isInteractive && "tw-cursor-pointer hover:tw-bg-cream focus-visible:tw-bg-cream focus-visible:tw-outline-focus",
        isSelected && "tw-bg-cream",
        !isSelected && !isInteractive && "tw-bg-transparent",
        className,
      )}
    >
      {children}
    </div>
  );
}
